import { render, staticRenderFns } from "./card-order-list.vue?vue&type=template&id=72fc49f5&scoped=true"
import script from "./card-order-list.vue?vue&type=script&lang=js"
export * from "./card-order-list.vue?vue&type=script&lang=js"
import style0 from "./card-order-list.vue?vue&type=style&index=0&id=72fc49f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc49f5",
  null
  
)

export default component.exports